import { render, staticRenderFns } from "./PaperHeader.vue?vue&type=template&id=6a655b8a&scoped=true"
import script from "./PaperHeader.vue?vue&type=script&lang=js"
export * from "./PaperHeader.vue?vue&type=script&lang=js"
import style0 from "./PaperHeader.vue?vue&type=style&index=0&id=6a655b8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a655b8a",
  null
  
)

export default component.exports